// extracted by mini-css-extract-plugin
export default {"brandPromo":"PG-z","carousel":"QG-z"};